module.exports = __webpack_public_path__ + "img/golfing.e6589fc3.svg";